import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {TorchTokenService} from '../../@backend/modules';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private urls = [
    '/torch/api/', // Development API
    'https://rest-staging.torchbi.com', // Staging API
    'https://rest-qa.torchbi.com', // Staging API
    'https://rest.torchbi.com', // Production API
    '/files/api', // Development Files API
    'https://files.torchbi.com', // Production/Staging Files API
  ];

  /**
   * Constructor
   */
  constructor(private tokenService: TorchTokenService) {
  }

  /**
   * Intercept
   *
   * @param req
   * @param next
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = req.url;

    if (this.urls.find(filteredURL => url.includes(filteredURL))) {
      return this.tokenService.getTokens().pipe(
        switchMap(tokens => next.handle(req.clone({
            headers: req.headers
              .set('Authorization', `Bearer ${tokens.torchToken}`)
              .set('msalToken', tokens.graphToken)
          })))
      );
    }

    // Acquire a token for this request, and attach as proper auth header.
    return next.handle(req);
  }
}
